import { render } from "./coopetition.vue?vue&type=template&id=1f26b572&scoped=true"
import script from "./coopetition.vue?vue&type=script&lang=js"
export * from "./coopetition.vue?vue&type=script&lang=js"

import "./coopetition.vue?vue&type=style&index=0&id=1f26b572&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f26b572"]])

export default __exports__